import { render, staticRenderFns } from "./CopTiposNovedadesOperativas.vue?vue&type=template&id=a2adc408&scoped=true"
import script from "./CopTiposNovedadesOperativas.vue?vue&type=script&lang=js"
export * from "./CopTiposNovedadesOperativas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2adc408",
  null
  
)

export default component.exports